package org.example.project.manager

import kotlinx.browser.window

object LumaticaApiSettings {

    lateinit var nodeIp: String
    lateinit var nodePort: String

    fun getBaseUrl(): String = window.location.origin
}